// FirebaseAuth.js
import { auth } from "./firebaseConfig";
import { signOut } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoggedIn, setUser } from "../reducers/userReducer";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { setLoginPopupOpen } from "../reducers/appReducer";

const FirebaseAuth = () => {
  const dispatch = useDispatch();
  const { t: translate } = useTranslation();
  const isLoggin = useSelector((state: any) => state.user.isLoggin);
  //const user = useSelector((state:any)=> state.user.user)
  const user = auth.currentUser;
  
    const openLoginPopup = () => {
      dispatch(setLoginPopupOpen(true));
    };
  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('access_token_fb_auth');
      localStorage.removeItem('user_data');
      dispatch(setUser(null));
      dispatch(setIsLoggedIn(false));
    } catch (error) {
      console.error("Error logging out: ", error);
    }
  };
  
  useEffect(() => {
    // Check for existing user session on component mount
    const unsubscribe = auth.onAuthStateChanged((user) => {
      console.log('Auth state changed:', user);
      if (user) {
        dispatch(setUser({
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
        }));
        dispatch(setIsLoggedIn(true));
      } else {
        // If no active Firebase session, check localStorage
        const storedUserData = localStorage.getItem('user_data');
        if (storedUserData) {
          const userData = JSON.parse(storedUserData);
          dispatch(setUser(userData));
          dispatch(setIsLoggedIn(true));
        } else {
          dispatch(setUser(null));
          dispatch(setIsLoggedIn(false));
        }
      }
    });
    
    return () => unsubscribe();
  }, [dispatch]);

  return (
    <div>
      {isLoggin && user ? (
        <div className="user-info container">
          <img src={user.photoURL || ''} alt="User Avatar" className="user-avatar" />
          <p>{user.displayName}</p>
          <button onClick={handleLogout} className="login-button">
            <span className="logout">
              {translate('logout')}
            </span>
            <i className="fa fa-sign-out" aria-hidden="true"></i>
          </button>
        </div>
      ) : (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <div onClick={openLoginPopup} className="credit-btn">
          <i className="fa-regular fa-user">
          </i>
          <div>Login</div>
          </div>
    </div>
      )}
    </div>
  );
};

export default FirebaseAuth;
